export const API_reminders = (): string => '/api/v2/reminders';
export const API_reminders_filtered = (timestampUntil: number): string =>
  `/api/v2/reminders?until=${timestampUntil}`;
export const API_reminders_point = (pointId: string): string =>
  `/api/v2/reminders/points/${pointId}`;
export const API_reminder = (reminderId: string): string => `/api/v2/reminders/${reminderId}`;
export const API_reminder_snooze = (): string => '/api/v2/reminders/snooze';
export const API_reminder_dismiss = (): string => '/api/v2/reminders/dismiss';
export const API_reminder_websocket = (): string => '/api/v1/ws-endpoint/user/topic/reminders';
export const API_reminders_search = (): string => '/api/reminders/search';
